<template>
  <div id="app">
    <!-- ======= Header ======= -->
    <header id="header" class="fixed-top">
      <div class="container d-flex">
        <div class="logo mr-auto">
          <!-- Uncomment below if you prefer to use an image logo -->
          <!-- <a href="index.html"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->
        </div>

        <nav class="nav-menu d-none d-lg-block">
          <ul>
            <li class="active"><a href="index.html">Home</a></li>
            <li><a href="#about">Chi Siamo</a></li>
            <li><a href="#salone">Salone</a></li>
            <li><a href="#hair_spa">Hair Spa</a></li>
            <li><a href="#centro_estetico">Centro Estetico</a></li>
            <li><a href="#servizi">Servizi</a></li>
            <li><a href="#promozioni">Promozioni</a></li>
            <li><a href="#contact">Contatti</a></li>
          </ul>
        </nav>
        <!-- .nav-menu -->
      </div>
    </header>
    <!-- End Header -->

    <!-- ======= Hero Section ======= -->
    <!--<section id="hero" class="d-flex flex-column justify-content-center align-items-center">
      <div class="container text-center text" data-aos="fade-up">
        <h1 style="font-family: serif; font-weight: normal; font-size: 70px">GIORGIO</h1>

        <h2>parrucchieri<span style="color: rgb(240, 224, 110)">|</span>hair spa<span style="color: rgb(240, 224, 110)">|</span>estetica</h2>

        <h3>NON IMITARE, <span style="color: rgb(240, 224, 110)">LASCIATI</span> IMITARE</h3>
      </div>
    </section>-->
    <hero-section></hero-section>
    <!-- End Hero -->

    <main id="main">
      <!-- ======= About Section ======= -->
      <text-image-section id="about" title="Chi Siamo" img="about.jpg" image_left>
        Il salone nasce con la visione di far vivere al cliente un’esperienza
        unica all’insegna del benessere. Crediamo fortemente nella cura di cute
        e capelli grazie al potere dei prodotti organici, che ci permettono di
        esprimere al meglio le nuove tendenze
      </text-image-section>
      <!-- End About Section -->

      <!-- ======= Salone Section ======= -->
      <section id="salone" class="salone">
        <div class="container">
          <div class="section-title" data-aos="fade-up">
            <h2>Salone</h2>
          </div>
          <swiper direction="horizontal" id="saloneCarousel" @swiper="saloneImagesSwiper" slidesPerView="1"
            class="swiper" effect="fade" autoHeight :pagination="{
              clickable: true,
              dynamicBullets: true,
            }" init loop data-aos="fade-up">
            <swiper-slide v-for="(image, index) in saloneImages" :key="index">
              <img :src="image" class="img-fluid saloneImg" alt="" :id="'saloneImg-' + index" @dblclick="openImageModal(image)" />
            </swiper-slide>
          </swiper>
        </div>
      </section>
      <!-- End Salone Section -->

      <!-- ======= Hair Spa Section ======= -->
      <text-image-section id="hair_spa" title="Hair Spa" img="home.jpg" image_left>
        <!-- HAIR SPA -->
        E' un centro benessere per capelli una beauty farm dove si fanno
        esclusivamente trattamenti per capelli. La cabina è illuminata secondo i
        principi della cromo terapia, musica a effetto relax, poltrona lavatesta
        che diventa lettino da massaggio. Diagnosi e trattamento della cute e
        dei capelli grazie alla tricocamera. La detersione dei capelli abbinato
        al massaggio stimola la circolazione a riequilibrare il ph della cute e
        a predisporre mente e corpo al relax La personalizzazione del
        trattamento ti garantirà capelli e cute più sani tanto relax e benessere
        psicofisico e ... infinite coccole ...
        <!-- ========== -->
      </text-image-section>
      <!-- End Hair Spa Section -->

      <!-- ======= Centro Estetico Section ======= -->
      <text-image-section id="centro_estetico" title="Centro Estetico" img="centro_estetico.jpg">
        <!-- CENTRO ESTETICO -->
        Elle, il nostro centro estetico composto da 2 cabine per trattamenti
        viso/corpo e massaggi, una cabina per manicure, pedicure e make up ed
        una doccia solare a bassa pressione dove ci si può abbronzare. Tutto
        all'insegna del relax
        <!-- ===================================== -->
      </text-image-section>
      <!-- End Centro Estetico Section -->

      <!-- ======= Servizi Section ======= -->
      <services-section commonTitle="Servizi" id="servizi" title1="Parrucchiere" title2="Estetica"
        :services1="column1Services" :services2="column2Services" :luxuryProducts="luxuryProducts">
        Un'esperienza unica guidata dal nostro team di esperti partendo dall'ascolto e dalla consulenza
      </services-section>

      <!-- ======= Promotions Section ======= -->
      <promotions-section></promotions-section>

      <!-- ======= Contact Section ======= -->
      <section id="contact" class="contact scrollto">
        <div class="container">
          <div class="section-title" data-aos="fade-up">
            <h2>Contatti</h2>
            <p></p>
          </div>
          <div class="row no-gutters justify-content-center" data-aos="fade-up">
            <div class="col-lg-5 d-flex align-items-stretch">
              <div class="info">
                <div class="address">
                  <i class="icofont-google-map"></i>
                  <h4>Via:</h4>
                  <p>Giovanni Giolitti, 13, 61122 Pesaro PU</p>
                </div>

                <div class="email mt-4">
                  <i class="icofont-envelope"></i>
                  <h4>Email:</h4>
                  <p>info@giorgioparrucchieri.com</p>
                </div>

                <div class="phone mt-4">
                  <i class="icofont-phone"></i>
                  <h4>Chiama:</h4>
                  <p>0721 54315</p>
                </div>

                <div class="contact_social mt-4">
                  <!-- <i class="icofont-phone"></i> -->
                  <h4>Social:</h4>
                  <p>
                    <a href="https://www.facebook.com/GiorgioParrucchieriPesaro/" class="facebook" target="_blank">
                      <i>
                        <icon :icon="icons.facebookIcon" height="24" class="icon" />
                      </i>
                    </a>
                    <a href="https://www.instagram.com/giorgioparrucchieri/" class="instagram" target="_blank">
                      <i>
                        <icon :icon="icons.instagramIcon" height="24" class="icon" />
                      </i>
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-5 d-flex align-items-stretch">
              <!--<iframe
                style="border: 0; width: 100%; height: 400px"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11500.249509042833!2d12.9088361!3d43.8959748!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe208d077985959df!2sGiorgio%20Parrucchieri!5e0!3m2!1sit!2sit!4v1603819696517!5m2!1sit!2sit"
                allowfullscreen
              ></iframe>-->
              <iframe style="border: 0; width: 100%; height: 400px"
                src="https://www.google.com/maps/d/embed?mid=1F_UCcDtk_lbimfp4SRpyUGII8n_NQyc&ehbc=2E312F"
                allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </section>
      <!-- End Contact Section -->
      <!--<book-banner></book-banner>-->
    </main>
    <!-- End #main -->

    <!-- ======= Footer ======= -->
    <footer id="footer">
      <div class="footer-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="footer-info">
                <h3>Giorgio Parrucchieri</h3>
                <p>
                  Via Giovanni Giolitti, 13, 61122 - Pesaro, PU<br /><br />
                  <strong>Telefono:</strong> 0721 54315<br />
                  <strong>Email:</strong> info@giorgioparrucchieri.com<br />
                </p>
                <div class="social-links mt-3">
                  <!-- <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>-->
                  <a href="https://www.facebook.com/GiorgioParrucchieriPesaro/" class="facebook" target="_blank">
                    <i>
                      <Icon :icon="icons.facebookIcon" height="24" />
                    </i>
                  </a>
                  <a href="https://www.instagram.com/giorgioparrucchieri/" class="instagram" target="_blank">
                    <i>
                      <Icon :icon="icons.instagramIcon" height="24" />
                    </i>
                  </a>

                  <!-- <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
                <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="copyright">
          &copy; Copyright <strong><span>Maxim</span></strong>. All Rights Reserved
        </div>
        <div class="credits">
          <!-- All the links in the footer should remain intact. -->
          <!-- You can delete the links only if you purchased the pro version. -->
          <!-- Licensing information: https://bootstrapmade.com/license/ -->
          <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/maxim-free-onepage-bootstrap-theme/ -->
          Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
        </div>
      </div>
    </footer>
    <!-- End Footer -->




    <a href="#" class="back-to-top"><i class="icofont-simple-up"></i></a>
    <transition name="fade">
      <div v-if="isImageModalOpen" class="image-lightbox" @click="closeImageModal">
        <button class="image-lightbox__close" type="button" aria-label="Close" @click.stop="closeImageModal">
          &times;
        </button>
        <img v-if="activeImageSrc" :src="activeImageSrc" alt="Salone" class="image-lightbox__img" @click.stop />
      </div>
    </transition>
  </div>
</template>

<script>
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import PromotionsSection from "./components/PromotionsSection.vue";
import HeroSection from "./components/HeroSection.vue";
import TextImageSection from "./components/TextImageSection.vue";
import ServicesSection from "./components/ServicesSection.vue";
import "bootstrap";
import * as $ from "jquery";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
//import "swiper/css/autoplay"
// import "swiper/swiper-bundle.css";
import { Icon } from "@iconify/vue";
import bxlFacebook from "@iconify-icons/bx/bxl-facebook";
import bxlInstagram from "@iconify-icons/bx/bxl-instagram";
import Constants from "./common.js";

// install Swiper components
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, EffectFade]);

// eslint-disable-next-line
const jQuery = require("jquery-easing");

export default {
  name: "App",
  data () {
    return {
      icons: {
        facebookIcon: bxlFacebook,
        instagramIcon: bxlInstagram,
      },
      swiperOptions: {
        direction: 'horizontal',
        effect: 'fade',
        loop: true,
        autoHeight: false,
        pagination: {
          clickable: true,
          dynamicBullets: true,
        },
      },
      saloneSwiper: null,
      saloneImages: [],
      column1Services: [],
      column2Services: [],
      luxuryProducts: [],
      isImageModalOpen: false,
      activeImageSrc: null,
    };
  },
  methods: {
    adjustCarouselHeight () {
      // Get the height of the first image and set the carousel height accordingly
      const firstImage = this.$refs.saloneSwiper.$el.querySelector('.swiper-slide img');
      if (firstImage) {
        const height = firstImage.clientHeight;
        this.$refs.saloneSwiper.$el.style.height = `${height}px`;
      }
    },
    saloneImagesSwiper (swiper) {
      this.saloneSwiper = swiper;
      this.updateSaloneSwiper();
    },
    async fetchProducts () {
      try {
        const response = await fetch(Constants.SERVICES_FILE);
        const data = await response.json();

        // Set the data properties with the fetched products
        this.column1Services = data.parrucchiere;
        this.column2Services = data.estetica;
        this.luxuryProducts = data.luxury;
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    },
    preloadImages (images) {
      const imagePromises = images.map((imageSrc) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = resolve;
          img.src = imageSrc;
        });
      });
      return Promise.all(imagePromises);
    },
    async loadSaloneImages () {
      try {
        const response = await axios.get(Constants.SALONE_IMAGES_FILE);

        this.saloneImages = response.data.map(
          (image) => Constants.IMAGES_FOLDER + image.src
        );

        // Ensure that images are preloaded before updating Swiper
        await this.preloadImages(this.saloneImages);
        await new Promise(resolve => setTimeout(resolve, 500));
        this.updateSaloneSwiper();
      } catch (error) {
        console.error('Error loading images:', error);
      }
    },
    updateSaloneSwiper () {
      if (this.saloneSwiper && typeof this.saloneSwiper.update === 'function') {
        this.$nextTick(() => {
          if (this.saloneSwiper && typeof this.saloneSwiper.update === 'function') {
            this.saloneSwiper.update();
          }
        });
      }
    },
    openImageModal (imageSrc) {
      this.activeImageSrc = imageSrc;
      this.isImageModalOpen = true;
      document.body.classList.add('no-scroll');
    },
    closeImageModal () {
      this.isImageModalOpen = false;
      this.activeImageSrc = null;
      document.body.classList.remove('no-scroll');
    },
    handleKeydown (event) {
      if (event.key === 'Escape' && this.isImageModalOpen) {
        this.closeImageModal();
      }
    },
  },
  async mounted () {
    this.fetchProducts(); // Call the fetchProducts method when the component is mounted
    this.loadSaloneImages();
    window.addEventListener('keydown', this.handleKeydown);
    // Smooth scroll for the navigation menu and links with .scrollto classes
    const scrolltoOffset = $("#header").outerHeight() - 1;

    function scrollToValue (value, time = 1500) {
      $("html, body").animate(
        {
          scrollTop: value - scrolltoOffset,
        },
        time,
        "easeInOutExpo"
      );
    }
    function scrollToSection (section, time = 1500) {
      scrollToValue($(section).offset().top, time);
    }


    $(document).on(
      "click",
      ".nav-menu a, .mobile-nav a, .scrollto",
      function (e) {
        if (
          location.pathname.replace(/^\//, "") ===
          this.pathname.replace(/^\//, "") &&
          location.hostname === this.hostname
        ) {
          const target = $(this.hash);
          if (target.length) {
            e.preventDefault();
            scrollToSection(this.hash);

            if ($(this).parents(".nav-menu, .mobile-nav").length) {
              $(".nav-menu .active, .mobile-nav .active").removeClass("active");
              $(this).closest("li").addClass("active");
            }
            if ($("body").hasClass("mobile-nav-active")) {
              $("body").removeClass("mobile-nav-active");
              $(".mobile-nav-toggle i").toggleClass(
                "icofont-navigation-menu icofont-close"
              );
              $(".mobile-nav-overly").fadeOut();
            }
            return false;
          }
        }
      }
    );

    // Mobile Navigation
    if ($(".nav-menu").length) {
      const mobileNav = $(".nav-menu").clone().prop({
        class: "mobile-nav d-lg-none",
      });
      $("body").append(mobileNav);
      $("body").prepend(
        '<button type="button" class="mobile-nav-toggle d-lg-none"><i class="icofont-navigation-menu"></i></button>'
      );
      $("body").append('<div class="mobile-nav-overly"></div>');

      $(document).on("click", ".mobile-nav-toggle", function () {
        $("body").toggleClass("mobile-nav-active");
        $(".mobile-nav-toggle i").toggleClass(
          "icofont-navigation-menu icofont-close"
        );
        $(".mobile-nav-overly").toggle();
      });

      $(document).on("click", ".mobile-nav .drop-down > a", function (e) {
        e.preventDefault();
        $(this).next().slideToggle(300);
        $(this).parent().toggleClass("active");
      });

      $(document).click(function (e) {
        const container = $(".mobile-nav, .mobile-nav-toggle");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          if ($("body").hasClass("mobile-nav-active")) {
            $("body").removeClass("mobile-nav-active");
            $(".mobile-nav-toggle i").toggleClass(
              "icofont-navigation-menu icofont-close"
            );
            $(".mobile-nav-overly").fadeOut();
          }
        }
      });
    } else if ($(".mobile-nav, .mobile-nav-toggle").length) {
      $(".mobile-nav, .mobile-nav-toggle").hide();
    }

    // Navigation active state on scroll
    const navSections = $("section");
    const mainNav = $(".nav-menu, .mobile-nav");

    $(window).on("scroll", function () {
      const curPos = $(this).scrollTop() + 200;

      navSections.each(function () {
        const top = $(this).offset().top;
        const bottom = top + $(this).outerHeight();

        if (curPos >= top && curPos <= bottom) {
          if (curPos <= bottom) {
            mainNav.find("li").removeClass("active");
          }
          mainNav
            .find('a[href="#' + $(this).attr("id") + '"]')
            .parent("li")
            .addClass("active");
        }
        if (curPos < 275) {
          $(".nav-menu ul:first li:first").addClass("active");
        }
      });
    });

    // Back to top button
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $(".back-to-top").fadeIn("slow");
      } else {
        $(".back-to-top").fadeOut("slow");
      }
    });

    $(".back-to-top").click(function () {
      scrollToValue(0);
      return false;
    });

    $(window).on("load", function () {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
      });
    });




  },
  components: {
    PromotionsSection,
    TextImageSection,
    Swiper,
    HeroSection,
    SwiperSlide,
    Icon,
    ServicesSection,
  },
  unmounted () {
    window.removeEventListener('keydown', this.handleKeydown);
    document.body.classList.remove('no-scroll');
  },
};
</script>

<style></style>
